// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { BrowserMatchTypeSchema } from '../inputTypeSchemas/BrowserMatchTypeSchema'
import { BrowserMatchLocationSchema } from '../inputTypeSchemas/BrowserMatchLocationSchema'
import { BrowserReplaceTypeSchema } from '../inputTypeSchemas/BrowserReplaceTypeSchema'
import { MatchReplaceOriginSchema } from '../inputTypeSchemas/MatchReplaceOriginSchema'

/////////////////////////////////////////
// BROWSER MATCH REPLACE RULE SCHEMA
/////////////////////////////////////////

export const BrowserMatchReplaceRuleSchema = z.object({
  matchType: BrowserMatchTypeSchema,
  matchLocation: BrowserMatchLocationSchema,
  replaceType: BrowserReplaceTypeSchema,
  applyTo: MatchReplaceOriginSchema.array(),
  id: z.string(),
  name: z.string(),
  enabled: z.boolean(),
  description: z.string().nullable(),
  matchPattern: z.string(),
  isRegex: z.boolean(),
  caseSensitive: z.boolean(),
  headerName: z.string().nullable(),
  replaceWith: z.string(),
})

export type BrowserMatchReplaceRule = z.infer<typeof BrowserMatchReplaceRuleSchema>

export default BrowserMatchReplaceRuleSchema;
